import Logo from './Logo.jsx';
import './Logo.less';

export default Logo;
